import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi, type Supplier } from '../../api/supplier';

export function PerformanceDashboardPage() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [perf, setPerf] = useState<unknown>(null);

  useEffect(() => {
    void supplierApi.listSuppliers().then(setSuppliers);
  }, []);

  async function load(id: string) {
    setPerf(await supplierApi.getPerformance(id));
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/suppliers" className="text-sm text-slate-600 hover:underline">← Supplier hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Performance dashboard</h1>
      <ul className="mt-4 space-y-2">
        {suppliers.map((s) => (
          <li key={s.id}>
            <button type="button" onClick={() => void load(s.id)}
              className="rounded border px-3 py-2 text-sm">{s.supplier_code} — Score {s.performance_score.toFixed(0)}</button>
          </li>
        ))}
      </ul>
      {perf != null && <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(perf, null, 2)}</pre>}
    </div>
  );
}
